var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.6231 33.2486L39.75 1.37688C37.9157 -0.45896 34.9387 -0.45896 33.1021 1.37688L26.484 7.99583L34.8792 16.3917C36.8308 15.7326 39.0679 16.1746 40.6229 17.73C42.1861 19.2948 42.6249 21.5511 41.9495 23.5093L50.0409 31.6008C51.9988 30.9262 54.2573 31.3623 55.8205 32.9283C58.006 35.1129 58.006 38.6532 55.8205 40.8387C53.6347 43.0249 50.0945 43.0249 47.9078 40.8387C46.2645 39.1941 45.8581 36.7799 46.6904 34.7551L39.1441 27.2084L39.1433 47.067C39.6765 47.3306 40.179 47.6826 40.6229 48.1249C42.8079 50.3093 42.8079 53.8491 40.6229 56.037C38.4375 58.2216 34.8957 58.2216 32.7125 56.037C30.5275 53.8491 30.5275 50.3093 32.7125 48.1249C33.2527 47.5856 33.8772 47.1777 34.5441 46.9043V26.8614C33.8772 26.5889 33.2534 26.1837 32.7125 25.6408C31.0574 23.9869 30.6589 21.5578 31.5076 19.5252L23.2316 11.2475L1.37716 33.1011C-0.459054 34.9385 -0.459054 37.9156 1.37716 39.7514L33.2503 71.6231C35.0853 73.459 38.0616 73.459 39.899 71.6231L71.6231 39.8993C73.459 38.0626 73.459 35.0844 71.6231 33.2486Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/Git.4dc06c33fa044c02e35950f630e98525.svg";
export { ForwardRef as ReactComponent };